class BlogFilters {
  constructor( element ) {
    this.element = element;
    this.activeFilter = element.querySelector(".main-blog__active-filter");
    this.clearUrl = element.dataset.clearUrl;

    this.renderCurrentFilter();
    this.element.addEventListener("click", this.handleClick.bind(this));
    this.initializeScrollableAside();
  }

  initializeScrollableAside() {
    this.aside = this.element.closest(".main-blog-editorial__aside");

    if ( !this.aside ) return;

    this.resizeFrame = null;
    this.updateAsideHeight = this.updateAsideHeight.bind(this);
    this.requestAsideHeightUpdate = this.requestAsideHeightUpdate.bind(this);

    this.updateAsideHeight();
    window.addEventListener("scroll", this.requestAsideHeightUpdate, {
      passive: true,
    });
    window.addEventListener("resize", this.requestAsideHeightUpdate);
    window.visualViewport?.addEventListener(
      "resize",
      this.requestAsideHeightUpdate
    );
  }

  requestAsideHeightUpdate() {
    if ( this.resizeFrame ) return;

    this.resizeFrame = window.requestAnimationFrame(() => {
      this.updateAsideHeight();
      this.resizeFrame = null;
    });
  }

  updateAsideHeight() {
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const visibleTop = Math.max(this.aside.getBoundingClientRect().top, 0);
    const bottomGap = 16;
    const availableHeight = Math.max(viewportHeight - visibleTop - bottomGap, 1);

    this.aside.style.setProperty(
      "--blog-filters-visible-height",
      `${availableHeight}px`
    );
  }

  renderCurrentFilter() {
    const currentFilter = this.element.querySelector(
      ".main-blog__filter[aria-current='page']"
    );

    if ( !currentFilter ) {
      this.clearActiveFilter();
      return;
    }

    this.renderActiveFilter(this.getFilterLabel(currentFilter));
  }

  handleClick( event ) {
    const filter = event.target.closest(".main-blog__filter");

    if ( !filter || !this.element.contains(filter) ) return;

    const blogFilter = this.element.querySelectorAll(".main-blog__filter[aria-current='page']")

    if ( blogFilter ) {
      blogFilter.forEach((item) => {
        item.removeAttribute("aria-current");
        item.classList.remove("main-blog__filter--active");
      });
    }  

    filter.setAttribute("aria-current", "page");
    filter.classList.add("main-blog__filter--active");
    this.renderActiveFilter(this.getFilterLabel(filter));
    const closestFilterGroup = filter.closest(".main-blog__filter-group");

    if ( closestFilterGroup ) {
      closestFilterGroup.removeAttribute("open");
    }
  }

  getFilterLabel( filter ) {
    const group = filter.closest(".main-blog__filter-group");
    const filterLabel = filter.textContent.trim();

    if ( group ) {
      const groupLabelElement = group.querySelector(":scope > .main-blog__filter-summary > span:first-child");
      if ( groupLabelElement ) {
        const groupLabel = groupLabelElement.textContent.trim();
        return `${groupLabel}: ${filterLabel}`;
      }
    }

    return filterLabel

  }

  renderActiveFilter( label ) {
    const facetRemove = document.createElement("facet-remove");
    const item = document.createElement("div");
    const link = document.createElement("a");

    item.className = "f-current__list__item";
    item.append(document.createTextNode(label));

    link.className = "f-current__list__cancel";
    link.href = this.clearUrl;
    link.setAttribute("aria-label", `Remove filter: ${label}`);
    link.innerHTML = `
      <svg class="svg-icon svg-icon--close" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 72 72">
        <path d="M57.76 59.59 36 38 14.24 59.59a1.41 1.41 0 0 1-1.99 0l-.83-.82a1.38 1.38 0 0 1 0-1.98L33.39 35 11.42 13.21a1.39 1.39 0 0 1 0-1.98l.83-.82a1.42 1.42 0 0 1 1.99 0L36 32l21.76-21.59a1.42 1.42 0 0 1 2 0l.83.82a1.39 1.39 0 0 1 0 1.98L38.62 35l21.97 21.79a1.39 1.39 0 0 1 0 1.98l-.83.82a1.42 1.42 0 0 1-2 0Z"/>
      </svg>
    `;

    item.append(link);
    facetRemove.append(item);
    this.activeFilter.replaceChildren(facetRemove);
    this.activeFilter.hidden = false;
  }

  clearActiveFilter() {
    this.activeFilter.replaceChildren();
    this.activeFilter.hidden = true;
  }
}

document.querySelectorAll("[data-blog-filters]").forEach((element) => {
  new BlogFilters(element);
});
